var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"w"},[_c('div',{staticClass:"mian_view",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("资讯")])])
}
var staticRenderFns = []

export { render, staticRenderFns }